export default __webpack_public_path__ + "static/media/girl-with-offer.ab1965fb.png";